import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Divider as DividerComponent } from '@/components/UI/Divider/Divider.styles';
import { Tooltip as TooltipComponent } from '@/components/Tooltip';
import { QuestionIcon as QuestionIconComponent } from '@/components/UI/Icons/Icons';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  border-radius: 21px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
    background-color: ${({ theme }) => theme.palette.primary.background};
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 10px;
`;

export const Divider = styled(DividerComponent)`
  margin: 5px 0;
  background-color: ${({ theme }) => theme.palette.secondary.border};
`;

export const Label = styled(Typography.Text)`
  display: flex;
  flex-wrap: nowrap;
  gap: 5px;
  align-items: center;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 14px;
`;

export const Value = styled(Typography.Text)`
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 14px;
  font-weight: 500;
`;

export const Tooltip = styled(TooltipComponent)`
  width: 335px;
  font-size: 13px;
  padding: 15px;
`;

export const QuestionIcon = styled(QuestionIconComponent)`
  display: block;
`;
